<template>
  <h5 v-show="showTitle">Wasabi Accounts</h5>
  <div class="row">
    <!-- Search -->
    <div class="col-3">
      <z-search v-model.trim="searchTerm" name="search" label="" placeholder="Search" :readonly="isLoading" />
    </div>
    <!-- Placeholder -->
    <div class="col-2">
      <div class="row">
        <div v-show="!isAccountChecked" class="col-3">
          <button class="btn btn-primary btn-sm" @click="addAccount">Add</button>
        </div>
        <div v-show="isAccountChecked" class="col-3">
          <button class="btn btn-primary btn-sm" @click="deleteAccount">Delete</button>
        </div>
        <div class="col">
          <div class="input-group">
            <span class="input-group-text">Filter:</span>
            <select v-model="filter" class="form-control">
              <option v-for="item of filters" :key="item.id" :value="item.value">
                {{ item.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <!-- Pagination -->
        <div class="col-2">
          <z-select v-model="pageSize" :options="pageSizes" label="" name="pageSize" :disabled="isLoading" />
        </div>
        <div class="col">
          <nav>
            <z-paginate v-model="page" :page-count="pages" />
          </nav>
        </div>
        <div class="col-2 text-right">
          <h5 class="mt-0 me-0" title="# items">{{ count }}</h5>
          <span class="custom-items">items</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { wasabiStore } from '@/stores/wasabi'
import ZSearch from '@/components/utilities/elements/Search.vue'
import ZSelect from '@/components/utilities/elements/Select.vue'
import ZPaginate from '@/components/utilities/elements/Paginate.vue'
export default {
  name: 'AccountHeader',
  components: {
    ZSearch,
    ZSelect,
    ZPaginate
  },
  props: {
    pageSizes: Array
  },
  data() {
    return {
      isChecked: false
    }
  },
  watch: {
    isAccountChecked() {
      this.isChecked = false
      if (this.isAccountChecked) {
        this.isChecked = true
      }
    }
  },
  emits: ['search', 'add', 'delete'],
  computed: {
    ...mapState(wasabiStore, ['loading', 'listParams', 'filters', 'isAccountChecked']),
    isLoading() {
      return this.loading.accounts
    },
    count() {
      return this.listParams.count
    },
    pages() {
      return this.listParams.pages
    },
    page: {
      get() {
        return this.listParams.page
      },
      set(value) {
        this.setListParam({
          name: 'page',
          value: parseInt(value)
        })
        this.search(parseInt(value))
      }
    },
    pageSize: {
      get() {
        return this.listParams.pageSize
      },
      set(value) {
        this.setListParam({
          name: 'pageSize',
          value: parseInt(value)
        })
        this.page = 1
      }
    },
    searchTerm: {
      get() {
        return this.listParams.searchTerm
      },
      set(value) {
        this.setListParam({
          name: 'searchTerm',
          value: value
        })
        this.page = 1
      }
    },
    filter: {
      get() {
        return this.listParams.filter
      },
      set(value) {
        this.setListParam({
          name: 'filter',
          value: value
        })
        this.page = 1
        this.change()
      }
    }
  },
  methods: {
    ...mapActions(wasabiStore, ['setListParam']),
    change() {
      this.search(this.page)
    },
    search() {
      this.$emit('search', this.page)
    },
    addAccount() {
      this.$emit('add')
    },
    deleteAccount() {
      this.$emit('delete')
    }
  }
}
</script>
<style lang="scss">
.filterIcon {
  top: 8px;
  font-size: 1.2em;
}
.filterListing {
  float: left;
}
.custom-items {
  right: 10px;
  top: -10px;
  position: relative;
}
</style>
